export default {
    install(vue, shareData) {
        vue.prototype.$ShareData = (function(data) {
            // 没有分享数据，提供空方法
            if (!data) {
                return { bind() {}, setResultShare() {}, getResultShare() {} }
            }
            // 存在分析数据
            const _shareData = data
            let _resultData = null
            return {
                bind(key, func) {
                    if (_shareData) {
                        const v = _shareData[key]
                        if (v) {
                            // 只读一遍
                            delete _shareData[key]
                            // 忽略错误
                            try {
                                func(v)
                            } catch (error) {
                                console.error('bind shareData:', key, error)
                            }
                        }
                    }
                },
                // 结果集组件
                setResultShare(resultData) {
                    _resultData = resultData
                    delete this.setResultShare
                },
                getResultShare(func) {
                    if (_resultData != null && _resultData != undefined) {
                        try {
                            func(_resultData)
                        } catch (error) {
                            console.error('bind resultShareData:', error)
                        } finally {
                            _resultData = null
                        }
                    }
                }
            }
        })(shareData)
    }
}
